import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { Floor } from "utils/floor";

type UseAddFloorMutationVariablesPayload = {
  name: string;
  s3Url?: string;
  transformationMatrix?: number[][];
  position: Position3D;
  metadata: {
    mpp?: number;
    height?: number;
    floorplan: {
      width: number;
      height: number;
    };
  };
}

const useAddFloorMutation = (projectId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UseAddFloorMutationVariablesPayload) => {
      if (!projectId) return;
      const { data } = await authApi.post<Floor>(`/project/${projectId}/floors`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["floors", projectId],
      });
    },
  });
};

export default useAddFloorMutation;
